/* KALAVERA — «Apagón». Sin dependencias. */
(() => {
  'use strict';
  const N = window.noche || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Dinero ---------- */
  function money(cents) {
    const fmt = N.money || '{{amount_with_comma_separator}} €';
    const v = (cents || 0) / 100;
    const sep = (n, d, th, dec) => {
      const [i, f] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dec + f : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: sep(v, 2, ',', '.'),
      amount_no_decimals: sep(v, 0, ',', '.'),
      amount_with_comma_separator: sep(v, 2, '.', ','),
      amount_no_decimals_with_comma_separator: sep(v, 0, '.', ','),
      amount_with_apostrophe_separator: sep(v, 2, "'", '.'),
      amount_with_space_separator: sep(v, 2, ' ', ',')
    }[k] || sep(v, 2, '.', ',')));
  }

  /* ---------- Cabecera ---------- */
  const header = $('[data-header]');
  if (header && header.classList.contains('hd--over')) {
    let ticking = false;
    const onScroll = () => {
      ticking = false;
      header.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
  }
  const menuBtn = $('[data-menu-toggle]');
  const mnav = $('#MobileNav');
  function setMenu(open) {
    if (!menuBtn || !mnav) return;
    menuBtn.setAttribute('aria-expanded', String(open));
    menuBtn.querySelector('span').textContent = open ? 'Cerrar' : 'Menú';
    mnav.hidden = !open;
    header.classList.toggle('is-solid', open || window.scrollY > window.innerHeight * 0.6);
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  menuBtn?.addEventListener('click', () => setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'));
  document.addEventListener('click', (e) => {
    if (menuBtn?.getAttribute('aria-expanded') !== 'true') return;
    if (!e.target.closest('#MobileNav') && !e.target.closest('[data-menu-toggle]')) setMenu(false);
  });

  /* ---------- Carrito ---------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;
  function openCart() {
    if (!drawer) { location.href = N.routes.cart; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
    document.documentElement.style.overflow = 'hidden';
    $('.cd__panel', drawer).focus();
  }
  function closeCart() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; }, 450);
    lastFocus?.focus?.();
  }
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      const changed = el.textContent !== String(n);
      el.textContent = n;
      el.hidden = !n;
      if (changed && n) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  async function refreshCart() {
    const res = await fetch(`${N.routes.root}?section_id=noche-cart-drawer`, { headers: { Accept: 'text/html' } });
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = $('[data-cart-inner]', doc);
    const inner = drawer && $('[data-cart-inner]', drawer);
    if (fresh && inner) inner.replaceWith(fresh);
    const n = parseInt($('[data-cart-count-src]', doc)?.textContent, 10) || 0;
    setCount(n);
    const page = $('[data-cart-page]');
    if (page) {
      const id = page.closest('.shopify-section')?.id.replace('shopify-section-', '');
      if (id) {
        const r = await fetch(`${N.routes.cart}?section_id=${id}`);
        const d = new DOMParser().parseFromString(await r.text(), 'text/html');
        const f = $('[data-cart-page]', d);
        if (f) page.replaceWith(f);
      }
    }
  }
  async function changeLine(line, quantity) {
    drawer?.classList.add('is-busy');
    try {
      await fetch(`${N.routes.cartChange}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
      });
      await refreshCart();
    } finally { drawer?.classList.remove('is-busy'); }
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener && drawer) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    const q = e.target.closest('[data-line][data-qty]');
    if (q) { e.preventDefault(); changeLine(q.dataset.line, q.dataset.qty); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeCart();
    else if (menuBtn?.getAttribute('aria-expanded') === 'true') { setMenu(false); menuBtn.focus(); }
  });
  drawer?.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const f = $$('a[href], button:not([disabled]), input, textarea, select', drawer).filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* API pública para otras secciones (taller Kody) */
  window.nocheCart = { refresh: refreshCart, open: openCart, money };

  /* ---------- Producto ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    let variants = [];
    try { variants = JSON.parse($('[data-pdp-json]', root).textContent); } catch (_) { return; }
    const form = document.getElementById(root.dataset.form);
    const idInput = form?.querySelector('input[name="id"]');
    const button = form?.querySelector('.product-form__submit');
    const label = form?.querySelector('[data-pdp-label]');
    const price = $('[data-pdp-price]', root);
    const err = $('[data-pdp-error]', root);
    const opts = $('[data-pdp-opts]', root);

    function selected() {
      return $$('fieldset', opts).map((fs) => fs.querySelector('input:checked')?.value);
    }
    function markAvailability(sel) {
      $$('fieldset', opts).forEach((fs, i) => {
        $$('input', fs).forEach((input) => {
          const test = sel.slice(); test[i] = input.value;
          const ok = variants.some((v) => v.available && v.options.every((o, j) => o === test[j]));
          input.nextElementSibling?.classList.toggle('is-na', !ok);
        });
      });
    }
    function update() {
      const sel = selected();
      const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
      markAvailability(sel);
      if (!form || !button) return;
      const available = !!(v && v.available) && !root.hasAttribute('data-soon');
      const dyn = $('[data-pdp-dyn]', root);
      if (dyn) dyn.hidden = !available;
      if (v) idInput.value = v.id;
      idInput.disabled = !available;
      button.dataset.kalaveraAvailable = String(available);
      const needsForm = form.dataset.kalaveraRequired === 'true' && form.dataset.kalaveraReady !== 'true';
      button.disabled = !available || needsForm;
      if (label && !root.hasAttribute('data-soon')) label.textContent = !v ? N.strings.unavailable : available ? N.strings.addToCart : N.strings.soldOut;
      if (v && price && !root.hasAttribute('data-soon')) price.innerHTML = money(v.price) + (v.compare > v.price ? ` <s>${money(v.compare)}</s>` : '');
      if (v) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url);
        if (v.media) $('[data-gal]', root)?.goToMedia?.(v.media);
      }
      if (err) err.hidden = true;
    }
    opts?.addEventListener('change', update);
    if (opts) markAvailability(selected());

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
      button.setAttribute('aria-busy', 'true');
      const before = label?.textContent;
      if (label) label.textContent = N.strings.adding;
      if (err) err.hidden = true;
      try {
        const res = await fetch(`${N.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message || 'No se ha podido añadir al carrito.');
        await refreshCart();
        openCart();
      } catch (ex) {
        if (err) { err.textContent = ex instanceof TypeError ? 'No hay conexión. Inténtalo de nuevo.' : ex instanceof SyntaxError ? 'No se ha podido añadir al carrito. Inténtalo de nuevo.' : ex.message; err.hidden = false; }
      } finally {
        button.removeAttribute('aria-busy');
        if (label) label.textContent = before;
      }
    });
  }
  $$('[data-pdp]').forEach(initProduct);

  /* ---------- Galería: flechas, miniaturas y deslizar ---------- */
  function initGallery(g) {
    const track = $('[data-pdp-media]', g);
    if (!track || g.dataset.ready) return;
    g.dataset.ready = '1';
    const slides = $$('.pdp__fig', track);
    const thumbs = $$('[data-gal-go]', g);
    const counter = $('[data-gal-i]', g);
    const prev = $('[data-gal-prev]', g), next = $('[data-gal-next]', g);
    let i = 0;
    const go = (n) => {
      i = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' });
    };
    const sync = () => {
      const n = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      i = Math.max(0, Math.min(slides.length - 1, n));
      if (counter) counter.textContent = i + 1;
      thumbs.forEach((t, k) => t.classList.toggle('is-on', k === i));
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    };
    let t = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(t); t = requestAnimationFrame(sync); }, { passive: true });
    prev?.addEventListener('click', () => go(i - 1));
    next?.addEventListener('click', () => go(i + 1));
    thumbs.forEach((b) => b.addEventListener('click', () => go(Number(b.dataset.galGo))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    });
    g.goToMedia = (id) => { const k = slides.findIndex((f) => f.dataset.mediaId === String(id)); if (k > -1) go(k); };
    sync();
  }
  $$('[data-gal]').forEach(initGallery);

  /* ---------- Tarjetas: la luz sigue al cursor ---------- */
  document.addEventListener('pointermove', (e) => {
    if (e.pointerType !== 'mouse') return;
    const card = e.target.closest?.('.card, .cols__tile');
    if (!card) return;
    const r = card.getBoundingClientRect();
    card.style.setProperty('--mx', `${((e.clientX - r.left) / r.width * 100).toFixed(1)}%`);
    card.style.setProperty('--my', `${((e.clientY - r.top) / r.height * 100).toFixed(1)}%`);
  }, { passive: true });

  /* ---------- Relacionados ---------- */
  $$('[data-related]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const r = await fetch(el.dataset.url);
      const d = new DOMParser().parseFromString(await r.text(), 'text/html');
      const f = $('[data-related]', d);
      if (f && f.children.length) el.innerHTML = f.innerHTML;
    } catch (_) {}
  });

  /* ---------- Ordenar colección ---------- */
  $$('[data-autosubmit]').forEach((f) => f.addEventListener('change', () => f.submit()));

  /* ---------- Apagón: la calabaza ilumina lo que tocas ---------- */
  function initApagon(root) {
    const scene = $('[data-apagon-scene]', root);
    const dark = $('[data-apagon-dark]', root);
    const lamp = $('[data-apagon-lantern]', root);
    if (!scene || !dark || !lamp) return;
    let w = 0, h = 0, x = 0, y = 0, tx = 0, ty = 0, t = 0;
    let raf = 0, last = 0, lastInput = -1e9, visible = true;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const home = () => [w * (w < 750 ? 0.5 : 0.64), h * (w < 750 ? 0.4 : 0.44)];
    function place() {
      const v = `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0)`;
      dark.style.transform = v;
      lamp.style.transform = v;
    }
    function measure() {
      const r = scene.getBoundingClientRect();
      w = r.width; h = r.height;
      if (!x && !y) { [x, y] = home(); [tx, ty] = [x, y]; }
      place();
    }
    function frame(now) {
      raf = 0;
      if (!visible || document.hidden) return;
      const dt = Math.min(64, now - (last || now)); last = now;
      const idle = now - lastInput > (fine ? 3500 : 2500);
      if (idle && !reduce.matches) {
        t += dt / 1000;
        const [hx, hy] = home();
        tx = hx + w * 0.2 * Math.sin(t * 0.33);
        ty = hy + h * 0.14 * Math.sin(t * 0.51 + 1.2);
      }
      const k = reduce.matches ? 1 : idle ? 0.04 : 0.2;
      x += (tx - x) * k; y += (ty - y) * k;
      place();
      const moving = Math.abs(tx - x) > 0.3 || Math.abs(ty - y) > 0.3;
      if (moving || (idle && !reduce.matches)) raf = requestAnimationFrame(frame);
    }
    const wake = () => { if (!raf) { last = 0; raf = requestAnimationFrame(frame); } };
    function aim(cx, cy) {
      const r = scene.getBoundingClientRect();
      tx = Math.max(0, Math.min(w, cx - r.left));
      ty = Math.max(0, Math.min(h, cy - r.top));
      lastInput = performance.now();
      wake();
    }
    scene.addEventListener('pointermove', (e) => { if (e.pointerType === 'mouse') aim(e.clientX, e.clientY); }, { passive: true });
    root.addEventListener('touchstart', (e) => aim(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
    root.addEventListener('touchmove', (e) => aim(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
    new ResizeObserver(() => { measure(); wake(); }).observe(scene);
    new IntersectionObserver(([en]) => { visible = en.isIntersecting; if (visible) wake(); }).observe(root);
    document.addEventListener('visibilitychange', wake);
    measure(); wake();
  }
  $$('[data-apagon]').forEach(initApagon);

  /* ---------- Cintas policiales: se cortan al pasar el cursor ---------- */
  function initTape(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    $$('[data-tape-band]', root).forEach((band) => {
      let busy = false;
      const cut = (clientX) => {
        if (busy || reduce.matches) return;
        busy = true;
        const r = band.getBoundingClientRect();
        const pct = Math.max(8, Math.min(92, (clientX - r.left) / r.width * 100));
        band.style.setProperty('--cut', pct.toFixed(1) + '%');
        requestAnimationFrame(() => band.classList.add('is-cut'));
        setTimeout(() => {
          band.classList.remove('is-cut');
          setTimeout(() => { busy = false; }, 950);
        }, 2600);
      };
      band.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') cut(e.clientX); });
      band.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') cut(e.clientX); });
    });
  }
  $$('[data-tape]').forEach(initTape);

  /* Editor de temas: re-inicializar secciones recargadas */
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-apagon]', e.target).forEach(initApagon);
    $$('[data-pdp]', e.target).forEach(initProduct);
    $$('[data-gal]', e.target).forEach(initGallery);
    $$('[data-tape]', e.target).forEach(initTape);
  });
})();
